var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 175,
    viewBox: "0 0 265 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17641_343480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.28535e-05 107.9C-0.300053 130.2 8.09995 152.5 24.9999 169.5C25.3999 169.9 25.6999 170.2 26.0999 170.5H124.8H222.9C225.6 159.3 227 147.9 226.9 136.5V0H-5.28535e-05V107.9Z",
    fill: "url(#paint0_linear_17641_343480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 67.3002C257.6 59.7002 247.3 55.0002 235.9 55.0002C228.3 55.0002 221.1 57.1002 215 60.8002C212.4 49.3002 202.2 40.7002 189.9 40.7002C177.2 40.7002 166.6 49.9002 164.5 62.1002C161.9 60.1002 158.6 59.0002 155 59.0002C148.9 59.0002 143.7 62.4002 141 67.4002H265V67.3002Z",
    fill: "#FFB7C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8 38.2002C76.6 38.2002 55.3 46.3002 39.2 62.4002C13.6 88.0002 13.6 129.6 39.2 155.2C49 165 62 170.4 75.9 170.4H181.4C194.4 132.8 184.7 90.6002 156.5 62.4002C140.3 46.3002 119 38.2002 97.8 38.2002Z",
    fill: "#0175EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3 160.1C135.9 141.5 135.9 111.3 117.3 92.8001C102.2 77.7001 77.5997 77.7001 62.4997 92.8001C56.4997 98.8001 53.1997 106.8 53.1997 115.2C53.1997 123.6 56.4997 131.6 62.4997 137.6C67.3997 142.5 73.9997 145.2 80.8997 145.2C87.8997 145.2 94.3997 142.5 99.2997 137.6C103.4 133.5 105.6 128.1 105.6 122.4C105.6 116.7 103.4 111.2 99.2997 107.2C95.8997 103.8 91.3997 102 86.5997 102C81.7997 102 77.2997 103.9 73.8997 107.2C72.5997 108.5 72.5997 110.7 73.8997 112C75.1997 113.3 77.3997 113.3 78.6997 112C80.7997 109.9 83.5997 108.8 86.4997 108.8C89.4997 108.8 92.1997 110 94.2997 112C97.0997 114.8 98.5997 118.5 98.5997 122.4C98.5997 126.3 97.0997 130 94.2997 132.8C90.6997 136.4 85.7997 138.4 80.6997 138.4C75.5997 138.4 70.6997 136.4 67.0997 132.8C62.3997 128.1 59.7997 121.9 59.7997 115.2C59.7997 108.6 62.3997 102.3 67.0997 97.6001C79.5997 85.1001 99.7997 85.1001 112.3 97.6001C128.2 113.5 128.2 139.4 112.3 155.3C102.5 165.1 89.4997 170.5 75.5997 170.5H103.1C108.3 167.8 113.1 164.4 117.3 160.1Z",
    fill: "#005CB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6 170.5H181.3C181.3 170.5 176 159.5 163.2 159.5C151.8 159.4 144.8 170.5 129.6 170.5Z",
    fill: "#004386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.846 170.451L252.846 170.451L252.846 110.451L246.846 110.451L246.846 170.451Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9 121H246.9V130.9H252.9V121Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3 122.9V116.9H195.3L199.3 122.9H259.3Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9 126.9H199.3V158H242.9V126.9Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9 128.9H201.3V156H240.9V128.9Z",
    fill: "#FFB7C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9 126.9H199.3V130.9H242.9V126.9Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9 128.9H201.3V130.9H240.9V128.9Z",
    fill: "#FF849A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17641_343480",
    x1: 113.495,
    y1: 170.475,
    x2: 113.495,
    y2: 4.16089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5551,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17641_343480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 174.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.b4d25543.svg";
export { ForwardRef as ReactComponent };